import telephoneService from '@/services/telephone-server.service'
import userService from '@/services/user.service'

export default {
	addTelephone({ dispatch }, params) {
		return telephoneService
			.createTelephone(params)
			.then((response) => {
				if (response.success || response.status) dispatch('alertSuccess', response.message, { root: true })
				else dispatch('alertError', response.message, { root: true })
			})
			.catch((error) => {
				dispatch('alertError', error.message, { root: true })
			})
	},
	updateTelephone({ commit, dispatch }, data) {
		return telephoneService
			.updateTelephone(data)
			.then((response) => {
				if (response.success || response.status) {
					// commit('UPDATE_USER', data)
					dispatch('alertSuccess', response.message, { root: true })
				} else dispatch('alertError', response.message, { root: true })
			})
			.catch((error) => {
				dispatch('alertError', error.message, { root: true })
			})
	},
	fetchTelephone({ commit, dispatch }, payload) {
		return telephoneService
			.getTelephones(payload)
			.then((response) => {
				commit('SET_TELEPHONES', response.data.data)
				commit('SET_INFO_DB', { totalPage: response.data.last_page, totalRow: response.data.total })
				return Promise.resolve(response.data.data)
			})
			.catch((error) => {
				dispatch('alertError', error.message, { root: true })
			})
	},
	showTelephone({ dispatch }, id) {
		return telephoneService
			.showTelephone(id)
			.then((response) => {
				return Promise.resolve(response.data)
			})
			.catch((error) => {
				dispatch('alertError', error.message, { root: true })
			})
	},
	removeTelephone({ commit, dispatch }, ids) {
		return telephoneService
			.deleteTelephone({ cids: ids })
			.then((response) => {
				dispatch('alertSuccess', response.message, { root: true })
			})
			.catch((error) => {
				dispatch('alertError', error.message, { root: true })
			})
	},
	async getListTelephone({ dispatch, commit }, data) {
		return await telephoneService
			.getListTelephone()
			.then((response) => {
				if ((response.success || response.status) && response.data) {
					// dispatch("alertSuccess", response.message, { root: true });
					commit('SET_TELEPHONE_FOLDER', response.data)
					commit('SET_TELEPHONES',response.data)
					return Promise.resolve(response.data)
				} else {
					dispatch('alertError', response.message, { root: true })
				}
			})
			.catch((error) => {
				dispatch('alertError', error, { root: true })
				return Promise.reject(false)
			})
	},
	async getListTelephoneByAuthFlg({ dispatch, commit}){
		return await telephoneService.getListTelephoneByAuthFlg()
			.then((response) => {
				if ((response.success || response.status) && response.data) {
					commit('SET_TELEPHONE_FOLDER', response.data)
					return Promise.resolve(response.data)
				} else {
					dispatch('alertError', response.message, { root: true })
				}
			})
			.catch((error) => {
				dispatch('alertError', error.message, { root: true })
				return Promise.reject(false)
			})
	},
	async getListUserForTelephone({ dispatch, commit }) {
		return await userService
			.getListUserForTelephone()
			.then((response) => {
				if (response.success && response.data) {
					return Promise.resolve(response.data)
				} else {
					dispatch('alertError', response.message, { root: true })
				}
			})
			.catch((error) => {
				dispatch('alertError', error, { root: true })
				return Promise.reject(false)
			})
	}
}
